// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationMessageBuilder_container__3MRWW","buttonContainer":"NotificationMessageBuilder_buttonContainer__36Rta"};